import useCalculatorState from 'hooks/useCalculatorState';
import { useCallback, useEffect, useState } from 'react';

import { IPropsWithClassName } from 'interfaces';
import styles from './styles';

export interface RangeProps extends IPropsWithClassName {
  id: string,
  value: number,
  onChange(value: number): void;
}

const Range = ({
  id,
  onChange,
  value,
  className,
}: RangeProps) => {
  const [maxValue, setMaxValue] = useState<number>(0);
  const [rangeSteps, setRangeSteps] = useState<number>(0);
  const [currentPercent, setCurrentPercent] = useState<number>(0);
  const componentStyles = styles.component(className);

  const {
    dimensions,
  } = useCalculatorState();

  const numberOfSteps = (maxValue / rangeSteps) + 1;

  const {
    type: unitType,
  } = dimensions;

  useEffect(() => {
    switch (unitType) {
      case 'MM':
        setMaxValue(200);
        setRangeSteps(25);
        break;
      case 'INCH':
        setMaxValue(8);
        setRangeSteps(1);
        break;
      default:
        break;
    }
  }, [unitType]);

  useEffect(() => {
    const roundValue = Math.round(value / rangeSteps) * rangeSteps;
    setCurrentPercent((roundValue / maxValue) * 100);
  }, [maxValue, rangeSteps, value]);

  const getStepsAmount = useCallback(
    () => Array.from({ length: numberOfSteps }, (_, i) => i * rangeSteps),
    [numberOfSteps, rangeSteps],
  );

  return (
    <div className={componentStyles}>
      <input
        type="range"
        id={id}
        min="0"
        max={maxValue}
        step={rangeSteps}
        className={styles.range}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      <label
        className={styles.label}
        htmlFor={id}
        style={{
          background: `linear-gradient(90deg, #41B6E6 0%, #41B6E6 ${currentPercent}%, #B4B6B7 ${currentPercent}%, #B4B6B7 100%)`,
        }}
      >
        {getStepsAmount().map((stepValue) => (
          <span className={styles.dots(Boolean(stepValue <= value))} key={`range-dot-${stepValue}`} />
        ))}
      </label>
      <div className={styles.values}>
        {getStepsAmount().map((stepValue, idx, arr) => (
          (idx === 0 || idx === arr.length - 1) && (
            <span key={`range-step-${stepValue}`} className={styles.value}>
              {stepValue}
            </span>
          )
        ))}
      </div>
    </div>
  );
};
export default Range;
